/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
const BusinessContextConsumer = React.createContext({});

const BusinessContextProvider = BusinessContextConsumer.Provider

const BusinessContextHolder = ({ children }) => {
  const [businessContext, setBusinessContext] = useState("");
  const [finishedBusinessLoad, setFinishedBusinessLoad] = useState(false);
  const instanceURL = window.location.hostname;
  const prevURL = useRef();
  // Load the Business context
  useEffect(async () => {
    if (instanceURL !== 'app.signaclass.com') {
    prevURL.current = instanceURL;
    const getContext = await axios.get(`/api/public_view/business_info/${instanceURL}`);

    setFinishedBusinessLoad(true);
    return setBusinessContext(getContext.data);
    }
  }, [instanceURL]);

  let currencySymbol;
  if (businessContext.currency === "GBP") {
    currencySymbol = "£";
  } else if (businessContext.currency === "USD") {
    currencySymbol = "$";
  } else {
    currencySymbol = "€";
  }

  const data = {
    businessID: businessContext.businessID,
    connectedAccountID: businessContext.connectedAccountID,
    currency: businessContext.currency,
    gtmTag: businessContext.gtmTag,
    logo: businessContext.logo,
    planType: businessContext.planType,
    tradeName: businessContext.tradeName,
    currencySymbol: currencySymbol,
    finishedBusinessLoad: finishedBusinessLoad,
    brandColour: businessContext.brandColour,
    generalTheme: businessContext.generalTheme,
    selfCancellation: businessContext.selfCancellation
  };
  return <BusinessContextProvider value={data}>{children}</BusinessContextProvider>;
};

export { BusinessContextHolder, BusinessContextConsumer };
